<template>
  <v-container>
    <div class="display-2 mb-7 mt-5 font-weight-thin" color="primary">
      {{ $tc("entities.entityFieldCustom.title", 2) }}
    </div>
    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
    <btn-a
      rounded
      color="primary"
      @click="editItem"
      :access="$access.entityFieldCustom.edit"
    >
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :noAction="noAction"
      :multiple="multiple"
      :singleSelect="singleSelect"
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
      @input="pagination.page = $event"
      @click="clickTable($event)"
      @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.entityFieldCustom.title', 1)"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected, $refs.form.isValid())"
      @delete="deleteItem(itemSelected, true)"
      :loading="loadingDialog"
      :accessConfirm="$access.entityFieldCustom.edit"
      :accessDelete="$access.entityFieldCustom.delete"
      :alert="form.alert"
    >
      <entityFieldCustomForm
        v-if="itemSelected"
        ref="form"
        v-model="itemSelected"
      />
    </dialog-d>
  </v-container>
</template>

<script>
import entityFieldCustomService from "@/services/entityFieldCustomService";
import entityFieldCustomForm from "../components/forms/entityFieldCustoms/entityFieldCustomForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
export default {
  mixins: [pageListMixing],
  components: { entityFieldCustomForm },

  data() {
    return {
      apiController: "entityFieldCustom",
      entityService: entityFieldCustomService,
      itemsCustom: [],
      searchFields: ["entity", "type", "group", "label"],
      headers: [
        {
          text: this.$t("entities.entityFieldCustom.props.entity"),
          align: "left",
          sortable: false,
          value: "entity",
        },
        {
          text: this.$t("entities.entityFieldCustom.props.type"),
          align: "left",
          sortable: false,
          value: "type",
        },
        {
          text: this.$t("entities.entityFieldCustom.props.label"),
          align: "left",
          sortable: false,
          value: "label",
        },

        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right",
        },
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [
            this.$access.entityFieldCustom.edit,
            this.$access.entityFieldCustom.show,
          ],
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.entityFieldCustom.delete,
        },
      ],
    };
  },
  methods: {
    async getModelDefault() {
      return {
        type: "",
        entity: "",
        group: null,
        label: "",
        seq: 1,
        comboValues: [],
      };
    },
  },
  async mounted() {
    await this.getItems();
    // this.items.forEach((i) => {
    //   //i.typeDesc = this.$fieldCustomType.find((c) => c.key == i.type)[0].value;
    //   i.entityNameDesc = this.$entityName.find(
    //     (c) => c.key == i.entityName
    //   )[0].value;
    // });
    // this.itemsCustom = this.items;
  },
};
</script>
